import { cn } from '@/lib/utils';

/** Logotipo oficial da LD Embalagens (mesmo arquivo usado pelo site, reduzido para 256 px). */
export const DEFAULT_LOGO_URL = '/logo-ld-embalagens.png';
/** Símbolo da logo (recorte sem o texto, proporção preservada) para espaços compactos. */
export const DEFAULT_LOGO_MARK_URL = '/logo-ld-mark.png';

/**
 * Identificação da marca. `compact` mostra só o símbolo (sidebar e cabeçalho mobile);
 * o completo traz a logo e o nome do produto e da empresa. Um `logoUrl` do tenant substitui
 * as duas versões, sempre com `object-contain` para não distorcer.
 */
export function Brand({
  logoUrl,
  name,
  compact = false,
  className,
}: {
  logoUrl?: string | null;
  name?: string;
  compact?: boolean;
  className?: string;
}) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <img
        src={logoUrl || (compact ? DEFAULT_LOGO_MARK_URL : DEFAULT_LOGO_URL)}
        alt={compact ? (name ?? 'LD Gestão') : ''}
        className={cn('shrink-0 object-contain', compact ? 'size-9' : 'size-10')}
      />
      {!compact ? (
        <span className="flex min-w-0 flex-col leading-tight">
          <span className="text-sm font-semibold">LD Gestão</span>
          {name ? (
            <span className="max-w-40 truncate text-[11px] text-muted-foreground">{name}</span>
          ) : null}
        </span>
      ) : null}
    </div>
  );
}
